function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './login.scss';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import HardRedirect from 'researcher/components/HardRedirect';
import Redirect from 'shared/components/Redirect';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Link from 'shared/components/Link';
import LoginMessage from 'researcher/components/LoginMessage';
import PreferredGroupWelcome from 'researcher/components/PreferredGroupWelcome';
import { T, useTranslate } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import { getApiBaseUrl } from 'shared/helper/request';
import PaddleScriptLoader from '../../../rubriq/workspace/PaddleScriptLoader';
import { trackForgotPasswordClicked } from '../helpers/passwordResetMixpanelEvents';
import LocalAuthEnabled from './LocalAuthEnabled';
import Providers from './Providers';
import LoginForm from './LoginForm';
import LogingV2 from './LoginV2';
import resolveCurieRedirect from './resolveCurieRedirect';
var Login = function Login(_ref) {
  var _searchParams$get;
  var loginUser = _ref.loginUser,
    status = _ref.status,
    providers = _ref.providers,
    localAuthEnabled = _ref.localAuthEnabled,
    referringUrl = _ref.referringUrl,
    loginMessage = _ref.loginMessage,
    addMessage = _ref.addMessage,
    failureMessage = _ref.failureMessage,
    otherLocalizationLogoutLinks = _ref.otherLocalizationLogoutLinks,
    user = _ref.user;
  var showNewLogin = featureEnabled('rubriq_ui_revamp');
  var _useState = useState(user.loggedIn ? user.homeDirectory : null),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var origin = (_searchParams$get = searchParams.get('origin')) !== null && _searchParams$get !== void 0 ? _searchParams$get : null;
  var regLink = referringUrl ? "/register?redirect=".concat(referringUrl) : '/register';
  if (origin) {
    regLink = regLink.concat(referringUrl ? '&' : '?', "origin=".concat(origin));
  }
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  useEffect(function () {
    if (!failureMessage) {
      return;
    }
    addMessage({
      type: 'error',
      message: failureMessage
    });
  }, []);
  var processLogin = function processLogin(response) {
    var loggedIn = response.loggedIn,
      redirectUri = response.redirectUri;
    if (loggedIn) {
      var target = referringUrl || redirectUri;

      // For curie free trial paths, navigate directly without a state update
      // to avoid an extra render/flash before the external redirect.
      if (target && /\/c\/curiefreetrialchina/i.test(target)) {
        var normalised = target.replace(/curiefreetrialchina/gi, 'CurieFreeTrialChina');
        resolveCurieRedirect("".concat(getApiBaseUrl()).concat(normalised));
        return;
      }
      if (target && /\/c\/curiefreetrial/i.test(target)) {
        var _normalised = target.replace(/curiefreetrial/gi, 'CurieFreeTrial');
        resolveCurieRedirect("".concat(getApiBaseUrl()).concat(_normalised));
        return;
      }
      setRedirect(target);
    }
  };

  // Wrap loginUser to always forward referringUrl + origin so actions.js
  // can skip wasted loadUser/loadApplication calls before a curie redirect.
  var loginUserWithContext = function loginUserWithContext(credentials) {
    return loginUser(credentials, referringUrl, origin);
  };
  if (redirect) {
    if (redirect.includes('/c/')) {
      return /*#__PURE__*/React.createElement(HardRedirect, {
        to: referringUrl || redirect
      });
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: referringUrl || redirect
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaddleScriptLoader, null), !showNewLogin ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PreferredGroupWelcome, null), /*#__PURE__*/React.createElement(LoginMessage, {
    message: loginMessage
  }), /*#__PURE__*/React.createElement(LocalAuthEnabled, {
    className: "container login new-button-styles ".concat(providers.length > 0 ? 'has-providers' : ''),
    redirect: !localAuthEnabled && !failureMessage,
    providers: providers,
    referringUrl: referringUrl
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Log in to your account"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log in to your account"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, translationExists('one account for aje and curie') && /*#__PURE__*/React.createElement(T, {
    source: "one account for aje and curie"
  }), /*#__PURE__*/React.createElement(T.md, {
    source: "account-login-message-ref",
    useLink: true,
    params: {
      regLink: regLink
    }
  })))), /*#__PURE__*/React.createElement(Providers, {
    providers: providers,
    referringUrl: referringUrl
  }), localAuthEnabled ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 offset-md-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center form-header"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Or log in with your email and password"
  })), /*#__PURE__*/React.createElement(LoginForm, {
    loginUser: loginUserWithContext,
    onUserLoginAttempt: processLogin,
    processing: status.processing
  }), /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, otherLocalizationLogoutLinks.map(function (logoutLink) {
    return /*#__PURE__*/React.createElement("img", {
      alt: "Logout link",
      key: logoutLink,
      src: logoutLink
    });
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/login/forgot-password",
    onClick: function onClick() {
      return trackForgotPasswordClicked({
        pageName: window.location.pathname,
        loginMethod: providers.length > 0 ? 'both' : 'email',
        emailPrefilled: false
      });
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "Forgot your password?"
  }))))) : null)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LogingV2, {
    providers: providers,
    referringUrl: referringUrl,
    loginUser: loginUserWithContext,
    onUserLoginAttempt: processLogin,
    processing: status.processing
  })));
};
export default Login;